
define('ldsh!modules/stats/templates/listing', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-box-item ed-box-item-stats">\n  <table class="ed-table ed-table-striped">\n    <thead>\n      <tr>\n        <th data-i18n="stats.total" class="ed-table-stats-company-th"></th>\n        <th>\n          ' +
((__t = (sumVisitors)) == null ? '' : __t) +
'\n        </th>\n        <th>\n          ' +
((__t = (sumVisits)) == null ? '' : __t) +
'\n        </th>\n        <th>\n          ' +
((__t = (sumConvert)) == null ? '' : __t) +
'\n        </th>\n        <th>\n          ' +
((__t = (sumPages)) == null ? '' : __t) +
'\n        </th>\n      </tr>\n      <tr>\n        <th data-i18n="stats.company" data-field="company" class="ed-table-stats-company-th">Empresa</th>\n        <th data-i18n="stats.visitors" data-field="visitors" class="ed-table-stats-visitors-th">Visitas</th>\n        <th data-i18n="stats.visits" data-field="visits" class="ed-table-stats-visits-th">Impresiones</th>\n        <th data-i18n="stats.convert" data-field="convert" class="ed-table-stats-convert-th">Conversiones</th>\n        <th data-i18n="stats.pages" data-field="pages" class="ed-table-stats-domains-th">Páginas</th>\n      </tr>\n    </thead>\n    <tbody class="js-item-container">\n    </tbody>\n  </table>\n</div>';

}
return __p
};});

